import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { startWith } from 'rxjs/operators';

@Component({
  selector: 'search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

  @Input() search: any;
  @Output() searchChange = new EventEmitter();

  constructor(
    private fb: FormBuilder,

  ) { }

  form: FormGroup;

  ngOnInit(): void {
    this.form = this.fb.group({
      nome: [this.search?.nome],
      via: [this.search?.via],
      civico: [this.search?.civico],
      cap: [this.search?.cap],
      comune: [this.search?.comune],
      partita_iva: [this.search?.partita_iva],
      codice_fiscale: [this.search?.codice_fiscale],
    });

    this.form.valueChanges.pipe(
      startWith(this.form.value)
    ).subscribe(v => this.searchChange.emit(v));

  }
}
